<template>
    <div>
        <div v-html="$t('contact.categories.touch.content')"></div>
        <div><img :src="require('@/assets/img/contact/ti_logo.png')" /></div>
    </div>
</template>

<script></script>